import { BlockATemplate } from '../types';

// Block A templates with level-specific questions
export const BLOCK_A_TEMPLATES: Record<string, BlockATemplate> = {
  '1': {
    levelId: '1',
    questions: [
      {
        id: 'what-learned-1',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🥁 was the rhythm boss in Rhythm 101!',
          '🏁 raced rhythms in Rhythm Rally!',
          '🧩 solved the Rhythm Puzzle!',
          '🎛️ made rhythms in Chrome Lab!'
        ],
        correctIndex: 1
      },
      {
        id: 'enjoyment-1',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '2': {
    levelId: '2',
    questions: [
      {
        id: 'what-learned-2',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🎯 won at Rhythm Simon Says!',
          '🧩 cracked the Beat Decoder rhythm puzzle!',
          '🚀 raced different rhythms in Rocket Race!',
          '🎤 shared my rhythm with the class!'
        ],
        correctIndex: 1
      },
      {
        id: 'enjoyment-2',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '3': {
    levelId: '3',
    questions: [
      {
        id: 'what-learned-3',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🚀 zoomed through Rocket Race with harmony!',
          '🍦 YEETED ice cream scoops with harmony!',
          '🗼 climbed the Scale Tower!',
          '🧱 built a music tower in Chordstruction!'
        ],
        correctIndex: 1
      },
      {
        id: 'enjoyment-3',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '4': {
    levelId: '4',
    questions: [
      {
        id: 'what-learned-4',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🏟️ battled in the Harmonidome with harmony!',
          '🚀 raced to hear happy (major) and sad (minor) harmony!',
          '🎹 leveled up harmony in Piano Clicker!',
          '🎤 rocked out with harmony in our class song!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-4',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '5': {
    levelId: '5',
    questions: [
      {
        id: 'what-learned-5',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🎻 learned about instrument families!',
          '📺 spotted instruments in videos!',
          '🚀 raced with instruments in Rocket Race!',
          '🤖 mixed instruments in Incredibox!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-5',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '6': {
    levelId: '6',
    questions: [
      {
        id: 'what-learned-6',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🚀 played Rocket Race with instruments!',
          '🚀 raced again with tricky instruments!',
          '🏟️ battled instruments in the Harmonidome!',
          '🎤 performed our class song with instruments!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-6',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '7': {
    levelId: '7',
    questions: [
      {
        id: 'what-learned-7',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🧪 tested my ears with melody in Tune Testers!',
          '🪜 climbed notes with melody steps, skips, and repeats!',
          '✏️ drew melody shapes on paper!',
          '🐛 played Hot Cross Buns with melody in Melopedes!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-7',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '8': {
    levelId: '8',
    questions: [
      {
        id: 'what-learned-8',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🚀 raced with melody from memes and composers!',
          '🎤 steered Tuna with my voice melody!',
          '🐛 made my own melody in Melopedes!',
          '🎤 performed my melody for the class!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-8',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '9': {
    levelId: '9',
    questions: [
      {
        id: 'what-learned-9',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🧭 found the A and B parts in form!',
          '🎮 played React Attack with form!',
          '🎛️ built ABA songs in Chrome Lab form!',
          '🥁 played Beat Decoders with song form!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-9',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '10': {
    levelId: '10',
    questions: [
      {
        id: 'what-learned-10',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🚀 raced loud and quiet dynamics in Rocket Race!',
          '🐦 flapped my Muse with dynamics (loud and soft)!',
          '🎻 explored orchestra dynamics (loud and soft)!',
          '🌧️ made a music rainstorm with dynamics!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-10',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '11': {
    levelId: '11',
    questions: [
      {
        id: 'what-learned-11',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '🎵 learned what music genres are!',
          '👯 danced to different genres!',
          '🧑‍🎤 added my favorite musicians to genres!',
          '🤖 created a genre song with AI!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-11',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  },
  '12': {
    levelId: '12',
    questions: [
      {
        id: 'what-learned-12',
        type: 'multiple_choice',
        prompt: 'What will you tell your grownups?\n\nIn class I...',
        options: [
          '⭐ replayed my favorite music missions!',
          '🎤 performed at our big music showcase!',
          '🏆 earned my music certificate!',
          '🎉 celebrated my music wins with friends!'
        ],
        correctIndex: 0
      },
      {
        id: 'enjoyment-12',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: {
          min: 1,
          max: 5,
          emojis: ['😡', '😕', '😐', '🙂', '😄']
        }
      }
    ]
  }
};

export const getBlockATemplate = (levelId: string): BlockATemplate | null => {
  return BLOCK_A_TEMPLATES[levelId] || null;
};